/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/open_credit': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M17.262 17.221c0-.674-.631-1.349-1.306-1.349s-1.326.675-1.326 1.349.577 1.172 1.263 1.35c-.404 0-.893.674-.893 2.022V23h2v-2.407c0-1.349-.5-2.022-.904-2.022.709-.176 1.166-.675 1.166-1.35zM16 10.674l-4.523 4.524h-3.57v.674h3.849L16 11.628l4.244 4.244h3.849v-.674h-3.57z"/><path pid="2" d="M21.675 13.175L16 7.5l-5.675 5.675H7.907v1.348h2.977L16 9.407l5.116 5.116h2.977v-1.348zM14.651 23.826h2.697v.674h-2.697z"/>'
  }
})
